module.exports = __webpack_public_path__ + "components/MapControl/svg/Gabinet lekarski.svg?a164caa8";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Gabinet lekarski.svg
// module id = 1928
// module chunks = 0